/* eslint-disable no-useless-escape */
import moment from "moment";
import { parseDateFlexible } from "../utils/utils.js";

const startingCharToWhiteSpaceOrEndOfLine = str => {
  return `(?:${str})\\S*(?=\\b)`;
};
// const startingCharToEndOfLine = (str) => {
//   return `\\s(?:${str}.*)`
// }
const startingCharToEndOfLine = str => {
  return `^${str}.*`;
};
export const returnStyle = code => {
  const result = QUERY_REGEX.filter(
    o => o.codes.includes(code) || o.codes.includes("ALL"),
  );
  return result;
};

const QUERY_REGEX = [
  {
    name: "NAM",
    exp: `(?:NAM/.*)(?=SEX)|(NAM/.*)`,
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ALL"],
  },
  {
    name: "NAME",
    exp: `^NAME:\\s*[^\\r\\n]+`,
    style: () => ({ backgroundColor: "blue", color: "white" }),
    codes: ["QDL", "QWX"],
  },
  {
    name: "MIS",
    exp: `MIS/.*(?=\\b)`,
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ALL"],
  },
  {
    name: "DOB",
    exp: `DOB/\\d{8}`,
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ALL"],
  },
  {
    name: "LIC/",
    exp: startingCharToWhiteSpaceOrEndOfLine("LIC/"),
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ALL"],
  },
  {
    name: "Driver Authorization Code",
    exp: startingCharToEndOfLine("DRIVER AUTHORIZATION ID: "),
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ALL"],
  },
  {
    name: "DATE OF BIRTH",
    exp: startingCharToWhiteSpaceOrEndOfLine("DATE OF BIRTH: "),
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ALL"],
  },
  {
    name: "VIN/",
    exp: startingCharToWhiteSpaceOrEndOfLine("VIN/"),
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ALL"],
  },
  {
    name: "PPN",
    exp: `(?:PPN/.*)(?=\\sPSX)|(?=PPN/).*`,
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["SNQ"],
  },
  {
    name: "PPB",
    exp: startingCharToWhiteSpaceOrEndOfLine("PPB/"),
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["SNQ"],
  },
  {
    name: "PLATE in Query Data",
    exp: startingCharToWhiteSpaceOrEndOfLine("PLATE: "),
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ALL"],
  },
  {
    name: "PLATE in Response",
    exp: startingCharToWhiteSpaceOrEndOfLine("VEHICLE REGISTRATION PLATE ID:"),
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ALL"],
  },
  {
    name: "NAME - OOS",
    exp: startingCharToEndOfLine("NAME:"),
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["DR"],
  },
  {
    name: "Exp Date - OOS RR",
    exp: startingCharToEndOfLine("EXP DATE:"),
    style: part => {
      const dateStr = part.split(" ")[2];
      const momentDate = moment(dateStr, "MM-DD-YY");
      const now = moment();
      const isExpired = now.isAfter(momentDate);
      return isExpired
        ? { backgroundColor: "red", color: "white" }
        : { backgroundColor: "green", color: "white" };
    },
    codes: ["RR"],
  },
  {
    name: "Valid Date",
    exp: startingCharToEndOfLine("VD"),
    style: part => {
      const dateStr = part.split(" ")[2];
      const momentDate = moment(dateStr, "MM-DD-YY");
      const now = moment();
      const isExpired = now.isAfter(momentDate);
      return isExpired
        ? { backgroundColor: "red", color: "white" }
        : { backgroundColor: "green", color: "white" };
    },
    codes: ["QDL"],
  },
  {
    name: "Valid Date_OOS",
    exp: `VEHICLE REGISTRATION EXPIRATION DATE:.*(?=\\b)`,
    style: part => {
      const arr = part.split(": ");
      const dateStr = arr[1];
      const momentDate = parseDateFlexible(dateStr);
      const now = moment();
      const isExpired = now.isAfter(momentDate);
      return isExpired
        ? { backgroundColor: "red", color: "white" }
        : { backgroundColor: "green", color: "white" };
    },
    codes: ["SVQ", "QVF"],
  },
  {
    name: "Expiration Date",
    exp: `EXPIRATION DATE:\\s*\\d{4}-\\d{2}-\\d{2}`,
    style: part => {
      const match = part.match(/EXPIRATION DATE:\s*(\d{4}-\d{2}-\d{2})/);
      const dateStr = match ? match[1] : null;
      const momentDate = dateStr ? moment(dateStr, "YYYY-MM-DD") : null;
      const now = moment();
      const isExpired = momentDate ? now.isAfter(momentDate) : false;
      return isExpired
        ? { backgroundColor: "red", color: "white" }
        : { backgroundColor: "green", color: "white" };
    },
    codes: ["ALL"],
  },
  {
    name: "Active Civil or Criminal Suspension Indicator Name",
    exp: "^FIELD NAME: Active Civil or Criminal Suspension Indicator$",
    style: (part, allText) => {
      // Find the index of this line in the full text
      const lines = allText.split(/\r?\n/);
      const idx = lines.findIndex(line => line === part);
      // Check if the next line is FIELD VALUE: Civil or Criminal
      if (
        idx !== -1 &&
        lines[idx + 1] &&
        /^FIELD VALUE: (Criminal|Civil)$/.test(lines[idx + 1])
      ) {
        return {
          backgroundColor: "red",
          color: "white",
        };
      }
      return {};
    },
    codes: ["ALL"],
  },

  {
    name: "Registration Status Description",
    exp: "^REGISTRATION STATUS DESCRIPTION:.*$",
    style: part => {
      if (/(Suspended|Expired) Registration/i.test(part)) {
        return { backgroundColor: "red", color: "white" };
      }
      if (/REGISTRATION STATUS DESCRIPTION:\s*Valid Registration$/i.test(part)) {
        return { backgroundColor: "green", color: "white" };
      }
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ALL"],
  },

  {
    name: "Active Civil or Criminal Suspension Indicator Value",
    exp: "^FIELD VALUE: (?:Criminal|Civil)$",
    style: () => ({
      backgroundColor: "red",
      color: "white",
    }),
    codes: ["ALL"],
  },
  {
    name: "REGISTERED TO",
    exp: startingCharToEndOfLine("REGISTERED TO: "),
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ALL"],
  },
  {
    name: "TITLE TO",
    exp: startingCharToEndOfLine("TITLE TO: "),
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ALL"],
  },
  {
    name: "VIN",
    exp: startingCharToEndOfLine("VIN: "),
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ALL"],
  },
  {
    name: "Extradition",
    exp: startingCharToEndOfLine("EXL/"),
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ALL"],
  },
  {
    name: "Armed and Dangerous",
    exp: startingCharToEndOfLine("CMC/"),
    style: () => {
      return { backgroundColor: "red", color: "white" };
    },
    codes: ["ALL"],
  },
  {
    name: "OLD VT Extradition",
    exp: startingCharToEndOfLine("NO EXTRADITION"),
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ALL"],
  },
  {
    name: "OLD VT Armed and Dangerous",
    exp: startingCharToEndOfLine("Armed and Dangerous"),
    style: () => {
      return { backgroundColor: "red", color: "white" };
    },
    codes: ["ALL"],
  },
  {
    name: "SDX Name",
    exp: /SDX\/[^.]+?\./,
    style: () => ({
      backgroundColor: "blue",
      color: "white",
    }),
    codes: ["ALL"],
  },
  {
    name: "Valid Date_IS",
    exp: `\\s\\d{2}/\\d{2}\\s`,
    style: part => {
      const momentDate = moment(part.trim(), "YY/MM").endOf("month");
      const now = moment();
      const isExpired = now.isAfter(momentDate);
      return isExpired
        ? { backgroundColor: "red", color: "white" }
        : { backgroundColor: "green", color: "white" };
    },
    codes: ["SVQ", "QVF"],
  },
  {
    name: "DOB_OOS",
    exp: `(?<=EXPIRATION DATE:)\s\d{4}\-\d{2}\-\d{2}`,
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["DR"],
  },
  {
    name: "VIN_OOS",
    exp: `VEHICLE ID:.*(?=\\b)`,
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["SVQ", "QVF"],
  },
  {
    name: "SUSP-S",
    exp: startingCharToWhiteSpaceOrEndOfLine("SUSP-S"),
    style: () => {
      return { backgroundColor: "red", color: "white" };
    },
    codes: ["QDL"],
  },
  {
    name: "CRIMINAL-DLS",
    exp: startingCharToWhiteSpaceOrEndOfLine("CRIMINAL-DLS"),
    style: () => {
      return { backgroundColor: "red", color: "white" };
    },
    codes: ["QDL"],
  },

  {
    name: "LP",
    exp: startingCharToWhiteSpaceOrEndOfLine("-LP"),
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["QDL"],
  },
  {
    name: "MOTORCYCLE ENFORCEMENT",
    exp: startingCharToWhiteSpaceOrEndOfLine("1-1-M"),
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["QDL"],
  },
  {
    name: "MKE Warning",
    exp: startingCharToEndOfLine("MKE/"),
    style: () => ({
      backgroundColor: "red",
      color: "white",
    }),
    codes: ["ALL"],
  },
  {
    name: "ERR - Invalid User Password",
    exp: `Invalid User Password`,
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ERR"],
  },
  {
    name: "ERR - Field Invalid data.",
    exp: `Field Invalid data`,
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ERR"],
  },
  {
    name: "ERR - Invalid destination",
    exp: `Invalid destination`,
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ERR"],
  },
  {
    name: "ERR - Invalid user ID",
    exp: `Invalid user ID`,
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ERR"],
  },
  {
    name: "ERR - Disabled user ID",
    exp: `Disabled user ID`,
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ERR"],
  },
  {
    name: "ERR - Change password rejected – Old password is incorrect",
    exp: `Change password rejected – Old password is incorrect.`,
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ERR"],
  },
  {
    name: "ERR - Change password rejected – New password was recently used",
    exp: `Change password rejected – New password was recently used.`,
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ERR"],
  },
  {
    name: "ERR - Change password rejected – Invalid user ID",
    exp: `Change password rejected – Invalid user ID`,
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ERR"],
  },
  {
    name: "ERR - Change password rejected – New password must contain 3 of num",
    exp: `Change password rejected – New password must contain 3 of num`,
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ERR"],
  },
  {
    name: "ERR - Invalid MFC Format",
    exp: `Invalid MFC Format`,
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ERR"],
  },
  {
    name: "ERR - Data Error for MFC name",
    exp: `Data Error for MFC name`,
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ERR"],
  },
  {
    name: "ERR - Certification date has expired",
    exp: `Certification date has expired`,
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ERR"],
  },
  {
    name: "ERR - Error during parsing XML",
    exp: `Error during parsing XML`,
    style: () => {
      return { backgroundColor: "blue", color: "white" };
    },
    codes: ["ERR"],
  },
];
